export default __webpack_public_path__ + "static/media/website.bda45071.svg";